import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    header: {
      title: translate({ id: 'modal.collectRecurrenceTargetRange.header.title' }),
    },
    radio: {
      order: translate({ id: 'modal.collectRecurrenceTargetRange.radio.order' }),
      future: translate({ id: 'modal.collectRecurrenceTargetRange.radio.future' }),
      all: {
        text: translate({ id: 'modal.collectRecurrenceTargetRange.radio.all' }),
        alert: translate({ id: 'modal.collectRecurrenceTargetRange.radio.all.alert' }),
      },
    },

    footer: {
      save: translate({ id: 'modal.collectRecurrenceTargetRange.footer.save' }),
      cancel: translate({ id: 'modal.collectRecurrenceTargetRange.footer.cancel' }),
    },
  }))

  return api
}
